var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M8.646 49.021a8.258 8.258 0 0 0 5.768-2.45 8.235 8.235 0 0 0 2.38-5.79c0-6.268-5.815-12.9-7.771-19.564a.408.408 0 0 0-.408-.303.398.398 0 0 0-.398.303C6.261 27.88.498 34.524.446 40.78c0 2.168.855 4.248 2.38 5.79a8.258 8.258 0 0 0 5.768 2.451",
    fill: "#5BDCFD"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "translate",
    dur: "1s",
    values: "0,-15;0,50;0,50",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.027 53.398h2.887V44.77h-2.887v8.628Z",
    fill: "#569B72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.26 45.298 1.692.894 4.645-8.76-1.691-.894-4.645 8.76Z",
    fill: "#569B72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.648 2.938A2.254 2.254 0 0 1 8.091.854c.28-.108.58-.16.88-.151h16.358a3.035 3.035 0 0 1 2.709 2.705v52.737c0 3.133-4.832 3.133-4.832 0V5.528H11.407v5.38c0 3.133-4.832 3.133-4.832 0V3.544c.002-.204.027-.408.073-.606Z",
    fill: "#5B98F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/faucet.b23be2bf381c5700e125bce4e02e02c6.svg";
export { ForwardRef as ReactComponent };